module.exports = __webpack_public_path__ + "img/back.ef2d5ab0.svg";